import React, { useState, useEffect, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { FaRegEye } from "react-icons/fa6";
import { AiOutlinePrinter } from "react-icons/ai";
import { clearRows } from '../../../Redux/actions/rowActions';
import { useDispatch, useSelector } from 'react-redux';
import "../pagination/pagination.css"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from 'react-spinners';
import { MdCancel } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import { getDepartment } from '../../../Redux/selecters';

const RequisitionListing = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL

    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchLoader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedtem, setSelectedItem] = useState(null);
    const [selectedCancelItem, setSelectedCancelItem] = useState(null);
    const [docModal, setDocModal] = useState(false);
    const role = useSelector(getDepartment);
    const onOpenModal = async () => {
        
        const params = new URLSearchParams();
        params.append('DocNo', selectedCancelItem?.requisitionNo);
        params.append('Action', "GetCanCancelStatusForPRByDocNo");
        const res = await apiService.getApiParamater('GET_REQ_COMMON', `?${params.toString()}`);
        let poCreated = res?.data?.result?.data?.POCreated
        
        if (poCreated === 0) {
            setDocModal(true)
        } else {
            toast.warning("PO has already been created for this requisition. You cannot cancel the requisition.")
            return
        }
    }
    const onCloseModal = () => setDocModal(false);
    const apiService = new ApiService();
    let navigate = useNavigate();
    const gridRef = useRef();
    const [permissions, setPermissions] = useState([]);
    let dispatch = useDispatch()
    useEffect(() => {
        getItems()
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Purchase Requisition");
        setPermissions(permissions[0]);
    }, []);
    const [formData, setFormData] = useState({
        reqNo: "",
        remarks: "",
        status: [{ label: 'All', value: 'All' }],
    });
    const StatusFilter = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '5', label: 'Hold' },
        { value: '2', label: 'Rejected' },
    ]; 
    const onGridReady = (params) => {
        gridRef.current = params.api;
        params.api.showLoadingOverlay();
    };
    const handleEdit = async () => {
        if (selectedRows?.length > 1) {
            toast.warning("Unable to Edit requisition")
            toast.warning("Select only one Requisition")
            return
        }
        let eye = false
        try {
            if (selectedtem?.requisitionNo) {
                const updatedData = { ...selectedtem, eye: eye };
                if (updatedData?.status === 1) {
                    const updatedData = { ...selectedtem, eye: !selectedtem.eye?.active };
                    dispatch(clearRows());
                    navigate("/Inventory/Requisition/PurchaseRequisition", { state: updatedData });
                } else {
                    dispatch(clearRows());
                    navigate(`/Inventory/Requisition/Update/${selectedtem?.requisitionNo}`, { state: selectedtem });
                }
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    const handlePrint = () => {
        if (!selectedRows.length) return;

        const token = localStorage.getItem("Token");
        const DB = localStorage.getItem("DataBase");

        if (!token) {
            alert("Auth token is missing! Unable to proceed.");
            return;
        }

        selectedRows.forEach((row, index) => {
            setTimeout(() => {
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;

                const popup = window.open(
                    "",
                    `ReportPopup_${index}`,
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = REPORT_URL;
                    form.target = `ReportPopup_${index}`;

                    [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "PurchaseRequisition" },
                        { name: "voucherNo", value: row.requisitionNo },
                    ].forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
            }, index * 1000); // 1 second gap between each popup
        });
    };
    const handleEye = (clickedRowData) => {
        if (clickedRowData?.requisitionNo) {
            dispatch(clearRows());
            const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
            navigate(`/Inventory/Requisition/PurchaseRequisition/${clickedRowData?.requisitionNo}`, { state: updatedData });
        } else if (selectedtem?.requisitionNo) {
            dispatch(clearRows());
            const updatedData = { ...selectedtem, eye: !selectedtem.eye?.active };
            navigate(`/Inventory/Requisition/PurchaseRequisition/${selectedtem?.requisitionNo}`, { state: updatedData });
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            gridRef.current?.showLoadingOverlay();
            setLoader(true)
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('reqType', "Purchase Requisition");
            params.append('ReqType2', "Purchase Request");
            params.append('id', formData?.reqNo || "");
            params.append('Status', formData?.status?.value || "");
            const res = await apiService.getApiParamater('GET_PR', `?${params.toString()}`);
            // const storeData = res?.data?.result?.filter(
            //     item => ["Purchase Request", "Purchase Requisition"].includes(item?.reqType)
            // );
            setLoading(false);
            setRowData(res.data.result || []);
            setLoader(false)
            gridRef.current?.hideOverlay();
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoader(false)
            gridRef.current?.hideOverlay();
            setLoading(false);
        }
    }
    const dateFormatter = (params) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : "";
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        { headerName: 'Req No', field: 'requisitionNo', suppressMovable: true, width: 140 },
        { headerName: 'Request Type', field: 'reqType', suppressMovable: true, width: 150 },
        { headerName: 'Location', field: 'approvalUser', suppressMovable: true, width: 140 },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 140 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 140 },
        { headerName: 'POrder NO', field: 'projectName', suppressMovable: true, width: 200 },
        { headerName: 'Remarks', field: 'remarks', suppressMovable: true, width: 140 },
        {
            headerName: 'Status', field: 'status',
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn cancel">Cancelled</button>);
                } else {
                    return params.value;
                }
            }, suppressMovable: true, width: 140
        },
        { headerName: 'Approved By', field: 'approvedBy', suppressMovable: true, width: 140 },
        { headerName: 'Modified By', field: 'modifiedBy', suppressMovable: true, width: 140 },
        {
            headerName: "Created Date", field: "requisitionDate",
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        { headerName: 'Email', field: 'Email', suppressMovable: true, width: 140 },
    ];
    const onCellClicked = async (event) => {
        if (event.colDef.field === 'requisitionNo') {
            const clickedRowData = event.data;
            dispatch(clearRows());
            handleEye(clickedRowData)
        }
    };
    const onSelectionChanged = async (event) => {
        const rows = event.api.getSelectedRows();
        setSelectedRows(rows);

        // const selected = event.api.getSelectedRows();
        const selected = rows[0];
        setSelectedCancelItem(selected)
        // setSelectedRow(selected.length === 1 ? selected[0] : null);
        const params = new URLSearchParams();
        params.append('DocNo', selected?.requisitionNo);
        params.append('DocumentType', "Purchase Requisition");

        try {
            const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
            const statuses = res?.data?.result?.map(item => item.status);
            const allAreZero = statuses.every(status => status === 0);
            const anyIsFive = statuses.some(status => status === 2);
            if (allAreZero || anyIsFive) {
                setSelectedItem(selected);
            } else {
                console.warn("No valid status to set the item.");
                setSelectedItem(null);
            }
        } catch (error) {
            setSelectedItem(null);
            console.error("Error fetching document status:", error);
        }
    };
    const clearAllRows = () => {
        dispatch(clearRows());
    };
    const handlenew = () => {
        clearAllRows();
        navigate('/Inventory/Requisition/PurchaseRequisition')
    };
    const handleClearFilters = () => {
        const clearedFormData = {
            reqNo: "",
            status: [{ label: 'All', value: 'All' }],
        };
        setFormData(clearedFormData);
        getItems(1, clearedFormData);
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handlelocChange = (selectedOption) => {
        setFormData({ ...formData, status: selectedOption });
    };
    const handleSaveCancelReq = async () => {
        
        if (!formData?.remarks) {
            toast.warning("Please Enter Remarks")
            return
        }
        let body = {
            recordId: selectedCancelItem?.recordId || 0,
            status: 3,
            requisitionNo: selectedCancelItem?.requisitionNo,
            remarks: formData?.remarks || ""
        }
        const response = await apiService.put("PUT_REQ_CANCELATION", body);
        toast.success(response?.data?.message)
        setDocModal(false)

    }
    return (
        <div className='p-4 '>
            <div className='gridBg mx-1' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row d-flex justify-content-between'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Requisition No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.reqNo}
                            name="reqNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Status</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 2,
                                height: 25,
                                minHeight: 25
                            })}
                            className="w-100 p-0"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.status}
                            onChange={(selectedOption) => handlelocChange(selectedOption)}
                            options={StatusFilter}
                        />
                    </div>
                    <div className='col'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                    <div className='col'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                <div className='d-flex justify-contant-between '>
                    <h5 className='col mainInvHead'>Purchase Requisition List</h5>
                    <div className='d-flex justify-content-end gap-1'>
                        {role === "Administration" ?
                            <div
                                onClick={onOpenModal}
                                className={`cancelBtn flex-end gap-2 ${!selectedCancelItem ? 'disabled' : ''}`}
                                style={{
                                    cursor: selectedRows.length > 0 ? "pointer" : "not-allowed"
                                }}
                            >
                                <MdCancel color="#fff" className="center mt-1" />
                                <div className="center">Cancel</div>
                            </div> : ""
                        }
                        <div
                            onClick={handleEye}
                            className={`mainbtnGry flex-end gap-2 ${!selectedtem ? 'disabled' : ''}`}
                            style={{ cursor: selectedtem ? 'pointer' : 'not-allowed' }}
                        >
                            <FaRegEye color='#fff' className='center mt-1' />
                            <div className='center'>View</div>
                        </div>
                        {permissions?.canUpdate === true ?
                            <div
                                onClick={selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? handleEdit : null}
                                className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.status === 0 || selectedtem?.status === 2 ? '' : 'disabled'
                                    }`}
                                style={{
                                    cursor: selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? 'pointer' : 'not-allowed',
                                }}
                            >
                                <GrEdit color='#fff' className='center mt-1 ' />
                                <div className='center'>Edit</div>
                            </div> : ''
                        }
                        <div
                            onClick={handlePrint}
                            className={`mainbtnRed flex-end gap-2 ${selectedRows.length === 0 ? "disabled" : ""}`}
                            style={{
                                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed"
                            }}
                        >
                            <AiOutlinePrinter color="#fff" className="center mt-1" />
                            <div className="center">Print</div>
                        </div>
                        {permissions?.canAdd === true ?
                            <div className='col center'>
                                <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                    <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                                </button>
                            </div>
                            : ''
                        }
                    </div>
                </div>
                <div className='gridshad  mt-3'>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            onGridReady={onGridReady}
                            loading={searchLoader}
                            enableFilter={true}
                            floatingFilter={true}
                            columnDefs={columnDefs}
                            onCellClicked={onCellClicked}
                            rowSelection="multiple"
                            onSelectionChanged={onSelectionChanged}
                        />
                    </div>
                    <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                </div>
            </div>
            <Modal size="md"
                show={docModal} onHide={() => setDocModal(false)}
                backdrop="static"
                contentLabel='Cancel Requisition'
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">Cancel Requisition</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className='d-flex gap-5'>
                            <h6>Requisition No :</h6>
                            <h6>{selectedCancelItem?.requisitionNo || "---"}</h6>
                        </div>
                        <div className="">
                            <label htmlFor="exchangeRate" className="form-label  pt-2 start">Remarks</label>
                            <textarea
                                type="number"
                                className="form-Input w-100"
                                onWheel={(e) => e.target.blur()}
                                id="remarks"
                                placeholder='Enter Remarks'
                                value={formData?.remarks}
                                onChange={handleInputChange}
                                name="remarks"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    {/* <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button> */}
                    <button className='mainbtnRed' onClick={handleSaveCancelReq}>Confirm Cancellation</button>
                </Modal.Footer>
            </Modal>
        </div>

    );
};
export default RequisitionListing;
